export const ADD_OPENED_CHILD_ID = 'sidebar/ADD_OPENED_CHILD_ID'
export const REMOVE_OPENED_CHILD_ID = 'sidebar/REMOVE_OPENED_CHILD_ID'
